import PropTypes from 'prop-types';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';
import 'moment/locale/pl';
import '../../../../styles/datepicker.scss';

const DateFilter = ({ config, onChange, value }) => {
  const handleChange = (selected) => {
    let date = null;

    if (selected) {
      date = moment(selected);

      if (config.dateFrom) {
        date = date.startOf('day').format('YYYY-MM-DD HH:mm:ss');
      }

      if (config.dateTo) {
        date = date.endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
    }

    onChange({
      target: {
        name: config.field,
        value: date === null ? undefined : date,
      },
    });
  };

  return (
    <div className={`filter ${config.hidden ? 'hidden' : ''}`}>
      {config.label ? <label htmlFor={config.field}>{config.label}</label> : <label>&nbsp;</label>}
      <DayPickerInput
        id={config.field}
        name={config.field}
        formatDate={formatDate}
        parseDate={parseDate}
        dayPickerProps={{
          localeUtils: MomentLocaleUtils,
          locale: 'pl',
        }}
        onDayChange={handleChange}
        format='YYYY-MM-DD'
        placeholder={config.placeholder}
        value={value}
        inputProps={{
          className: 'filter-input filter-date',
        }}
      />
    </div>
  );
};

DateFilter.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
DateFilter.defaultProps = {
  value: '',
};

export default DateFilter;
